import { z } from 'zod';

import { idSchema, isoDateSchema, jsonMetaSchema } from './common.schema';

export const csatScaleSchema = z.enum(['1_to_5', '0_to_10', 'thumbs']);

export const csatInvitationSchema = z.object({
  id: idSchema,
  ticket_id: idSchema,
  contact_id: idSchema,
  operator_id: idSchema.nullable().optional(),
  scale: csatScaleSchema,
  sent_via: z.string(),
  sent_at: isoDateSchema,
  expires_at: isoDateSchema,
  answered_at: isoDateSchema.nullable().optional(),
});

/** Public-flow: клиент отправляет ответ через token (без auth). */
export const submitCsatPublicSchema = z.object({
  token: z.string().min(8).max(128),
  score: z.number().int().min(0).max(10),
  comment: z.string().max(2000).optional(),
});

export const csatResponseSchema = z.object({
  id: idSchema,
  invitation_id: idSchema,
  ticket_id: idSchema,
  contact_id: idSchema,
  operator_id: idSchema.nullable().optional(),
  score: z.number().int(),
  comment: z.string().nullable().optional(),
  meta: jsonMetaSchema.default({}),
  created_at: isoDateSchema,
});
export type CsatResponse = z.infer<typeof csatResponseSchema>;
